import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import useFetchDommages from '../hooks/useFetchDommages';
import { sanitizeText } from '../utils/SanitizeText';

import Loader from '../components/Loader';
import ListDommage from '../components/ListDommage';

const DommageList = () => {
    const navigate = useNavigate();
    const { dommages, fetchDommages, loading, error } = useFetchDommages();


        const didFetchRef = useRef(false);

    useEffect(() => {
        if (didFetchRef.current) return;
        didFetchRef.current = true;
        fetchDommages();
    }, [fetchDommages]);

    // if (loading) {
    //     return <div className="flex flex-1 justify-center items-center"><Loader /></div>;
    // }

    if (error) {
        return <div>Erreur : {error}</div>;
    }

    const DommagesSain = dommages
        .filter(dommage => dommage.Libelle !== "")
        .map(dommage => ({
            ...dommage,
            Libelle: sanitizeText(dommage.Libelle)
        }));

    const handleRowDoubleClick = (event) => {
        const clickedRowData = event.rowData;
        const uuid = clickedRowData.UUID_;
        if (uuid) navigate(`/dommages/${uuid}`);
    };

    console.log("DommagesSain", DommagesSain);

    return (
        <div class="flex-1 p-6 lg:p-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12">
                        <div class="flex items-center bg-gray-900 drop-shadow-xl mb-6 px-8 rounded-lg w-full min-h-20">
                            <div id="url" class="flex gap-x-2 font-semibold text-gray-400 text-sm sm:text-lg">
                                <Link to="/dommages" class="hover:text-white decoration-orange-600 hover:underline hover:underline-offset-2 transition hover:translate-y-[-2px] duration-300">Dommages</Link>
                                <span class="cursor-default">/</span>
                            </div>
                        </div>
                        <ListDommage lstDommages={DommagesSain} loading={loading} handleRowDoubleClick={handleRowDoubleClick} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DommageList;
